<i18n>
{
  "fr": {
    "BugReport": "Anomalies",
    "PullRequestReport": "Pull requests",
    "Title": "Kezber Reports",
    "VelocityReport": "Vélocité",
    "AvailabilityReport": "Disponibilité",
    "PreSaleAnalysisActivitiesReport": "Analyse prévente",
    "WorkItemsWordExportReport": "Work Items Export"
  }
}
</i18n>

<template>
  <div
    v-if="!navbarHidden"
    class="kez-navigation">
    <div class="sidebar">
      <div class="navbar navbar-light bg-white border-bottom navbar-expand">
        <p
          v-t="'Title'"
          class="navbar-brand mr-0 mb-0 text-center w-100"/>
      </div>
      <div class="sidebar-content">
        <AppNavigationCategory
          v-for="(category, index) in categories"
          :key="index"
          :label="$t(category.label)"
          :to="category.to"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppNavigationCategory from './AppNavigationCategory';
import AppNavigationLink from './AppNavigationLink';

export default {
  components: {
    AppNavigationCategory,
    AppNavigationLink,
  },
  data() {
    return {
      categories: [
        {
          label: 'VelocityReport',
          to: { name: 'Velocity' },
        },
        {
          label: 'PullRequestReport',
          to: { name: 'PullRequest' },
        },
        {
          label: 'BugReport',
          to: { name: 'Bug' },
        },
        {
          label: 'AvailabilityReport',
          to: { name: 'Availability' },
        },
        {
          label: 'PreSaleAnalysisActivitiesReport',
          to: { name: 'PreSaleAnalysisActivitiesGenerate' },
        },
        {
          label: 'WorkItemsWordExportReport',
          to: { name: 'WorkItemsWordExportReportGenerate' },
        },
      ],
    };
  },
  computed: {
    navbarHidden() {
      return !!this.$route.meta.hideNavbar;
    },
  },
  watch: {
    navbarHidden: {
      handler(newVal) {
        const [body] = window.document.getElementsByTagName('body');
        if (newVal) {
          body.classList.remove('sidebar-present');
        } else {
          body.classList.add('sidebar-present');
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
$expanded-width: 15rem;
$collapsed-width: 4.75rem;
$navbar-height: $nav-link-height + ($navbar-padding-y * 2);

body.sidebar-present {
  padding-left: $expanded-width;
  transition: padding-left ease 0.4s;

  &.sidebar-minimized {
    padding-left: $collapsed-width;

    .kez-navigation .navbar.fixed-top {
      left: $collapsed-width;
    }
  }

  .kez-navigation .navbar.fixed-top {
    left: $expanded-width;
  }
}

body.navbar-present {
  padding-top: $navbar-height;
}

.kez-navigation {
  .navbar {
    transition: left ease 0.4s;

    /deep/ .navbar-nav {
      .navbar-link {
        padding: 0;

        i {
          font-size: 24px;
          line-height: 24px;
        }
      }
    }
  }

  .sidebar {
    position: fixed;
    top: 0;
    bottom: 0; // 4.5rem;
    left: 0;
    width: $expanded-width;
    border-right: 1px solid $gray-500;
    background: $white;
    transition: width ease 0.4s;

    .sidebar-content {
      height: calc(100% - #{$navbar-height});
      overflow-y: auto;
    }

    .sidebar-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      width: $expanded-width;
      transition: width ease 0.4s;
      background: $light;
      border-top: 1px solid $gray-500;
      border-right: 1px solid $gray-500;

      .btn-toggle {
        border-radius: 0;
        background: $gray-400;
        border-color: $gray-400;

        i {
          font-size: $h4-font-size;
        }

        &:hover,
        &:focus {
          background: $gray-500;
        }
      }
    }

    &.minimized {
      width: $collapsed-width;
    }
  }
}
</style>
